import React from "react";
import { t } from "ttag";
import { useStoreState } from "../../../models/RootStore";
import ProfessionalPackagesTree, { SinglePackageTree } from "./PackageTrees";
import useSiteSetupInputs, { SectionTitle } from "./useSiteSetupInputs";

// Setup form, bottom: Professional Packages tree, Support Debug and Trial packages (same as Edit Site)
const PackagesSection = () => {
  const { formik, third, renderDate, labelWithHint } = useSiteSetupInputs();
  const { values, setFieldValue } = formik;
  const { sitePackagesNamesEnums = {}, sitePackagesFlagsEnums = {} } = useStoreState((s) => s.types);

  // Package display names, the same source Edit Site uses
  const packageName = (flag: any, fallback: any) => {
    const key = Object.keys(sitePackagesFlagsEnums).find((id) => sitePackagesFlagsEnums[+id] === flag);
    return (key && sitePackagesNamesEnums[+key]) || fallback;
  };

  const proPackages = [
    { name: "hvacAdvancedOperations", label: packageName("hvacAdvancedOperations", t`Advanced HVAC Operations`) },
    { name: "predictiveMaintenance", label: packageName("predictiveMaintenance", t`Predictive Maintenance`) }
  ].map((option) => ({ ...option, checked: !!values[option.name] }));

  const handleProPackageChange = (name: any, checked: any) => {
    setFieldValue(name, checked);
  };

  const handleDebugPackageChange = (checked: any) => {
    setFieldValue("debugPackageEnabled", checked);
  };

  const handleTrialPackageChange = (checked: any) => {
    setFieldValue("trialPackageEnabled", checked);
  };

  return (
    <>
      <SectionTitle>{t`Packages`}</SectionTitle>
      {third(
        <ProfessionalPackagesTree
          packages={proPackages}
          onChange={handleProPackageChange}
        />,
        "proPackages"
      )}
      {third(
        <SinglePackageTree
          nodeId="trialPackage"
          checked={values.trialPackageEnabled}
          onChange={handleTrialPackageChange}
          label={labelWithHint(
            t`Customer Trial Period`,
            t`Assign predictive maintenance package for the site, Applies for site users with professional app access`
          )}
        >
          {renderDate("trialPackageExpiresAt", t`Trial package expires on`, {
            disablePast: true,
            disabled: !values.trialPackageEnabled,
            hint: t`Default 30 days. Can be extended.`
          })}
        </SinglePackageTree>,
        "trialPackage"
      )}
      {third(
        <SinglePackageTree
          nodeId="debugPackage"
          checked={values.debugPackageEnabled}
          onChange={handleDebugPackageChange}
          label={labelWithHint(
            t`CA customer support debug`,
            t`Assign predictive maintenance package for the site, for support people only (only applies when impersonating)`
          )}
        >
          {renderDate("debugPackageExpiresAt", t`Debug package expires on`, {
            disablePast: true,
            disabled: !values.debugPackageEnabled,
            hint: t`Default 14 days. Can be extended.`
          })}
        </SinglePackageTree>,
        "debugPackage"
      )}
    </>
  );
};

export default PackagesSection;
